import type { ReactNode } from "react";
import { ProjectLink } from "./ProjectLink";
import { fmtLocation } from "../helpers/format";
import type { StockLocation } from "../api-models";

interface LocationLabelProps {
  location?: StockLocation | null;
  /** Rendered when the document carries no location at all. */
  fallback?: ReactNode;
}

/**
 * A store is shown under the project that owns it, with the project part linking through
 * (ProjectLink) — the SiteLabel rule applied to stock locations. Central warehouse and
 * sink locations belong to no project and keep their bare name, as does a site store whose
 * Site.Project wasn't preloaded, so a missing preload degrades rather than blanks out.
 */
export function LocationLabel({ location, fallback = null }: LocationLabelProps) {
  if (!location) return <>{fallback}</>;
  const project = location.site?.project;
  if (!project) return <>{location.name}</>;
  return (
    <>
      <ProjectLink project={project} /> / {location.name}
    </>
  );
}

// A link has no text of its own to walk in a CSV export (helpers/csv.ts).
LocationLabel.csvText = ({ location, fallback }: LocationLabelProps) => (location ? fmtLocation(location) : fallback);
